import {
  getUsernameChildRedux, setUsernameChildRedux, getEmailChildRedux, setEmailChildRedux, setOpenChildModal, getOpenRedux,
  setOpenRedux, getResetFeedbackRedux, setResetFeedbackRedux, getOpenChildModalRedux,
  setOpenChildModalRedux,
  getEmailResetRedux,
  setEmailResetRedux,
  getUsernameResetRedux,
  setUsernameResetRedux,
  setOpenModalResetByEmailRedux,
  getOpenModalResetByEmailRedux,
  getLoadingRedux,
  setLoadingRedux,
  getLoadingModalResetByEmailRedux,
  setLoadingModalResetByEmailRedux
} from "../libs/loginSlice"
import React from "react";
import { useSelector, useDispatch } from "react-redux"
import axios from 'axios'
import { Button, Modal, Box, OutlinedInput, Alert } from "@mui/material";
import Swal from "sweetalert2";
import TabIndexContent from "react-tabindex-content";
import { useEffect } from "react";
import { TrendingUpRounded } from "@mui/icons-material";
import LoadingComponent from "../lib/LoadingComponent";
import { getStyle } from "../libs/todoSlice";
import fontColor from "../lib/fontColor";
import FadeIn from "react-fade-in/lib/FadeIn";

const ResetPasswordByEmail = () => {
  const dispatch = useDispatch();
  const username = useSelector(getUsernameResetRedux)
  const setUsername = (action) => {
    dispatch(setUsernameResetRedux({
      usernameReset: action
    }))
  }
  const style = useSelector(getStyle)

  const email = useSelector(getEmailResetRedux)
  const setEmail = (action) => {
    dispatch(setEmailResetRedux({
      emailReset: action
    }))
  }

  const loading = useSelector(getLoadingModalResetByEmailRedux)
  const setLoading = (action) => {
    dispatch(setLoadingModalResetByEmailRedux({
      loadingModalResetByEmail: action
    }))
  }

  useEffect(() => {
    setUsername('')
    setEmail('')
    setLoading(false)
  }, []);

  const open = useSelector(getOpenRedux)
  const setOpen = (action) => {
    dispatch(setOpenRedux({
      open: action
    }))
  }

  const resetFeedback = useSelector(getResetFeedbackRedux)
  const setResetFeedback = (action) => {
    dispatch(setResetFeedbackRedux({
      resetFeedback: action
    }))
  }

  const openModalResetByEmail = useSelector(getOpenModalResetByEmailRedux)
  const setOpenChildModal = (action) => {
    dispatch(setOpenModalResetByEmailRedux({
      openModalResetByEmail: action
    }))
  }




  // const [openChildModal, setOpenChildModal] = useState(false);
  // const [usernamechild,setUsernameChild] = useState('');
  // const [emailchild,setEmailChild] = useState('');


  const resetByEmail = async () => {
    setLoading(TrendingUpRounded)
    await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/password/reset/email`,
      data: {
        username: username,
        email: email,
      }
    }).then(({ data, status }) => {
      setResetFeedback({
        message: 'ส่งการรีเซ็ตพาสเวิดไปที่ E-mail เรียบร้อยแล้ว',
        color: 'success'
      })
      setTimeout(() => {
        setOpenChildModal(false);
        setOpen(false)
        setLoading(false)
        setResetFeedback({
          message: '',
          color: ''
        })
      }, 5000);
    }, ({ response }) => {

      setResetFeedback({
        message: 'ข้อมูลไม่ถูกต้อง',
        color: 'error'
      })
      setTimeout(() => {
        setResetFeedback({
          message: '',
          color: ''
        })
      }, 5000);
      setLoading(false)
    })
  }
  return (
    <React.Fragment>
      <Button
        variant="contained"
        style={{
          background: !!style.secondary_color ? `${style.secondary_color}` : 'rgb(5, 48, 117)',
          color: style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF',
          borderRadius: '6px',
          width: '150px',
          height: '36px',
          marginRight: '10px'
        }}
        onClick={() => {
          setOpenChildModal(true);
        }}>
        รีเซ็ตด้วยอีเมล
      </Button>
      <Modal
        open={openModalResetByEmail}
        onClose={() => {
          setOpenChildModal(false);
        }}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: '16px',
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          width: "99%",
          maxWidth: "500px",
        }}>
          <TabIndexContent global={true} allowReadOnly={true}>
            <div className="container">
              <div className="row">
                <div className="col">
                  <h6 id="child-modal-title">กรุณากรอก username</h6>
                  <OutlinedInput
                    value={username}
                    inputProps={{
                      tabIndex: '0'
                    }}
                    style={{
                      width: '100%',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      marginTop: '10px',
                      marginBottom: '15px',
                    }}
                    placeholder="username"
                    onChange={(e) => {
                      setUsername(e.target.value)
                    }}
                    onKeyPress={({ key }) => {
                      if (key === 'Enter' && email.length !== 0 && username.length !== 0) {
                        resetByEmail()
                      }
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6 id="child-modal-title">กรุณากรอก e-mail</h6>
                  <OutlinedInput
                    inputProps={{
                      tabIndex: '1'
                    }}
                    style={{
                      width: '100%',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      margin: '10px 0',
                    }}
                    placeholder="e-mail"
                    value={email}
                    onKeyPress={({ key }) => {
                      if (key === 'Enter' && email.length !== 0 && username.length !== 0) {
                        resetByEmail()
                      }
                    }}
                    onChange={(e) => {
                      setEmail(e.target.value)
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div
                    style={{
                      marginBlock: "10px"
                    }}
                  >
                    {resetFeedback.message.length > 0 && <FadeIn><Alert severity={resetFeedback.color}>{resetFeedback.message}</Alert></FadeIn>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-center text-md-end mr-0">
                  <Button
                    variant="outlined"
                    style={{
                      color: !!style.secondary_color ? `${style.secondary_color}` : 'rgb(5, 48, 117)',
                      borderColor: !!style.secondary_color ? `${style.secondary_color}` : 'rgb(5, 48, 117)',
                      borderRadius: '6px',
                      width: '90px',
                      height: '36px',
                      marginRight: '10px'
                    }}
                    onClick={() => {
                      setOpenChildModal(false);
                    }}>
                    กลับ
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      background: !!style.secondary_color ? `${style.secondary_color}` : 'rgb(5, 48, 117)',
                      borderRadius: '6px',
                      width: '90px',
                      height: '36px',
                      color: !!style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF'
                    }}
                    disabled={loading || email.length === 0 || username.length === 0}
                    onClick={() => {
                      resetByEmail()
                    }}>
                    {loading === false ?
                      <>ยืนยัน</>
                      :
                      <LoadingComponent width={50} height={50} />
                    }
                  </Button>
                </div>
              </div>
            </div>
          </TabIndexContent>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export default ResetPasswordByEmail;
